import { render, staticRenderFns } from "./LabelFormScreen.vue?vue&type=template&id=686e2422&"
import script from "./LabelFormScreen.vue?vue&type=script&lang=ts&"
export * from "./LabelFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports